function ChevronDoubleLeft() {
  return (
    <svg width={34} height={40} viewBox="0 0 34 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.523 39.683L12.598 20.766a1.077 1.077 0 010-1.524L31.523.325a1.077 1.077 0 011.524 0l.637.637a1.077 1.077 0 010 1.524L16.157 20.004 33.675 37.53a1.077 1.077 0 010 1.524l-.636.637a1.074 1.074 0 01-1.516-.01zm-9.951 0l.636-.637a1.077 1.077 0 000-1.524L4.681 20.004 22.2 2.477a1.077 1.077 0 000-1.524l-.636-.637a1.077 1.077 0 00-1.524 0L1.113 19.233a1.077 1.077 0 000 1.524l18.926 18.917c.43.43 1.111.43 1.533.009z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default ChevronDoubleLeft;
